import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-muted/30 border-t pt-16 pb-8">
      <div className="container mx-auto px-4">

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">

          {/* Logo + About */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img className="max-h-12" src="https://acetn.org/images/acetn_logo.png" alt="ACE TN" />
              <span className="font-display text-xl">ACE TN</span>
            </div>

            <p className="text-muted-foreground text-sm leading-relaxed">
              is a 501(c)3 nonprofit tax-exempt charitable organization (tax ID 33-4908557). Donations are tax-deductible.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold mb-4 font-heading">Quick Links</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/" className="hover:text-primary transition-colors">Home</a></li>
              {/* <li><a href="/donate" className="hover:text-primary transition-colors">Donate</a></li> */}
              <li><a href="/library" className="hover:text-primary transition-colors">Digital Library</a></li>
              <li><a href="/services" className="hover:text-primary transition-colors">Community Services</a></li>
              <li><a href="/#programs" className="hover:text-primary transition-colors">Our Programs</a></li>
              <li><a href="/#stats" className="hover:text-primary transition-colors">Literacy Stats</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold mb-4 font-heading">Contact</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-center gap-2">
                📍 <span>Maryville Tennessee, USA</span>
              </li>
              <li className="flex items-center gap-2">
                ✉️ <a href="mailto:contact@acetn.org">contact@acetn.org</a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="font-bold mb-4 font-heading">Follow Us</h3>

            <div className="flex gap-4">
              <a href="https://www.instagram.com/animeclubeasttn/" className="bg-white p-2 rounded-full border hover:border-primary hover:text-primary transition-colors">
                📷
              </a>

              <a href="https://www.facebook.com/people/Anime-Club-of-East-TN/61571945206508/" className="bg-white p-2 rounded-full border hover:border-primary hover:text-primary transition-colors">
                👍
              </a>

              <a href="https://discord.gg/wxtmRBvbBZ" className="bg-white p-2 rounded-full border hover:border-primary hover:text-primary transition-colors">
                💬
              </a>

            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t pt-8 text-center text-sm text-muted-foreground">
          <p>&copy; {year} ACE TN. All rights reserved.</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;